/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetBillingMetadataRequestBody,
  SetBillingMetadataRequestBody$Outbound,
  SetBillingMetadataRequestBody$outboundSchema,
} from "../components/setbillingmetadatarequestbody.js";

export type SetBillingMetadataSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetBillingMetadataRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setBillingMetadataRequestBody: SetBillingMetadataRequestBody;
};

/** @internal */
export type SetBillingMetadataSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetBillingMetadataSecurity$outboundSchema: z.ZodMiniType<
  SetBillingMetadataSecurity$Outbound,
  SetBillingMetadataSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setBillingMetadataSecurityToJSON(
  setBillingMetadataSecurity: SetBillingMetadataSecurity,
): string {
  return JSON.stringify(
    SetBillingMetadataSecurity$outboundSchema.parse(setBillingMetadataSecurity),
  );
}

/** @internal */
export type SetBillingMetadataRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetBillingMetadataRequestBody: SetBillingMetadataRequestBody$Outbound;
};

/** @internal */
export const SetBillingMetadataRequest$outboundSchema: z.ZodMiniType<
  SetBillingMetadataRequest$Outbound,
  SetBillingMetadataRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    setBillingMetadataRequestBody: SetBillingMetadataRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      setBillingMetadataRequestBody: "SetBillingMetadataRequestBody",
    });
  }),
);

export function setBillingMetadataRequestToJSON(
  setBillingMetadataRequest: SetBillingMetadataRequest,
): string {
  return JSON.stringify(
    SetBillingMetadataRequest$outboundSchema.parse(setBillingMetadataRequest),
  );
}
